// trader_agent_frontend/src/components/TermsOfService/TermsOfService.jsx
import React from 'react';
import styles from './TermsOfService.module.css';

const TermsOfService = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Terms of Service</h1>
          <p className={styles.lastUpdated}>Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          
          <section className={styles.section}>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using OnServ Trader ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.</p>
          </section>

          <section className={styles.section}>
            <h2>2. Description of Service</h2>
            <p>OnServ Trader provides algorithmic trading backtesting tools and financial data analysis services for educational and research purposes.</p>
          </section>

          <section className={styles.section}>
            <h2>3. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your password</li>
              <li>Accept all risks of unauthorized access to your account</li>
              <li>Use the Service for lawful purposes only</li>
              <li>Not engage in any activity that interferes with the Service</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>4. Intellectual Property</h2>
            <p>The Service and its original content, features, and functionality are owned by OnServ and are protected by international copyright, trademark, and other intellectual property laws.</p>
          </section>

          <section className={styles.section}>
            <h2>5. Disclaimer of Warranties</h2>
            <p>The Service is provided "as is" without any warranties, express or implied. We do not guarantee that:</p>
            <ul>
              <li>The Service will be uninterrupted or error-free</li>
              <li>The results obtained from the Service will be accurate or reliable</li>
              <li>The quality of any products, services, or information will meet your expectations</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>6. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, OnServ shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.</p>
            <p><strong>Important:</strong> OnServ Trader is for educational and research purposes only. It is not financial advice, and you should consult with qualified financial professionals before making investment decisions.</p>
          </section>

          <section className={styles.section}>
            <h2>7. Termination</h2>
            <p>We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users.</p>
          </section>

          <section className={styles.section}>
            <h2>8. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. We will provide notice of significant changes. Your continued use of the Service after changes constitutes acceptance.</p>
          </section>

          <section className={styles.section}>
            <h2>9. Governing Law</h2>
            <p>These Terms shall be governed by the laws of [Your State/Country] without regard to its conflict of law provisions.</p>
          </section>

          <section className={styles.section}>
            <h2>10. Contact Information</h2>
            <p>Questions about the Terms of Service should be sent to:</p>
            <p className={styles.contact}>
              Email: support@onserv.com<br />
              Address: ONSERV 30 N Gould St Ste 6087 Sheridan, WY 82801 USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;